import { DialogAwareContentContainer, DialogContent } from "../shared";

export const AdblockerDetectedDialog = () => {
    return (
        <DialogContent className="max-w-md w-[300px] md:w-screen">
            <DialogAwareContentContainer isDialog={true}>
                <div className="text-sm px-4 pb-4">
                    This feature requires third-party tracking, which is currently being blocked. Potentially due to an
                    ad-blocker or privacy extension. Please disable any ad-blocker extensions or privacy tooling to
                    proceed.
                </div>
            </DialogAwareContentContainer>
        </DialogContent>
    );
};
